import { render, staticRenderFns } from "./aOrderDetail.vue?vue&type=template&id=447dc455&scoped=true"
import script from "./aOrderDetail.vue?vue&type=script&lang=js"
export * from "./aOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./aOrderDetail.vue?vue&type=style&index=0&id=447dc455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447dc455",
  null
  
)

export default component.exports